export const NotImplementedError = () => {
  throw new Error(`NotImplementedError\nRange-specific implementation needed`);
};
